import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useAuth } from "./AuthContext";
import { Home } from "@mui/icons-material";
import image2 from "./profilenobacklogo.png";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    if (name && password) {
      try {
        const response = await fetch(
          "https://sirius.runasp.net/api/Account/Login",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              UserName: name,
              Password: password,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        login(data.token, data.expiration);
        navigate("/dashboard");
      } catch (error) {
        setError("Login failed. Please try again.");
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setError("Invalid name or password");
      setLoading(false);
    }
  };

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Link
        to="/"
        style={{
          textDecoration: "none",
          position: "absolute",
          top: "10px",
          left: "10px",
        }}
      >
        <Button
          variant="contained"
          color="error"
          aria-label="Home"
          sx={{
            backgroundColor: "#f44336",
            padding: "5px",
            borderRadius: "50%",
            minWidth: "40px",
            minHeight: "40px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Home sx={{ fontSize: "1.5rem", color: "#fff" }} />
        </Button>
      </Link>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "8px",
          padding: "2rem",
          flexDirection: "column",
          width: "100%",
          maxWidth: "400px",
          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <img
          src={image2}
          alt="admin"
          style={{
            height: "auto",
            width: "200px",
            objectFit: "cover",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        />
        <Typography
          variant="h4"
          sx={{
            mb: 3,
            color: "#f44336",
            textAlign: "center",
          }}
        >
          Sirius Admin
        </Typography>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
          onSubmit={handleLogin}
        >
          <TextField
            fullWidth
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            margin="normal"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#f44336",
                },
                "&:hover fieldset": {
                  borderColor: "#e57373",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#f44336",
                },
              },
            }}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#f44336",
                },
                "&:hover fieldset": {
                  borderColor: "#e57373",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#f44336",
                },
              },
            }}
          />
          {error && (
            <Typography
              color="error"
              variant="body2"
              sx={{ mt: 2, color: "#f44336" }}
            >
              {error}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            sx={{
              mt: 2,
              width: "100%",
              backgroundColor: "#f44336",
              "&:hover": {
                backgroundColor: "#f00336",
              },
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default AdminLogin;
